import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "loadingLayer"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "page page-reports page-table" }
const _hoisted_5 = { class: "selector" }
const _hoisted_6 = { class: "actions hide-sp" }
const _hoisted_7 = { class: "page-table-body-wrapper" }
const _hoisted_8 = { class: "page-table-body page-reports-body" }
const _hoisted_9 = {
  key: 0,
  class: "table-head-wrapper",
  style: {"height":"30px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "time" }, " ", -1)
const _hoisted_11 = ["colspan"]
const _hoisted_12 = {
  class: "time",
  rowspan: "2"
}
const _hoisted_13 = ["colspan"]
const _hoisted_14 = { class: "table-head table-head-fix hide-print" }
const _hoisted_15 = { class: "time" }
const _hoisted_16 = {
  key: 1,
  class: "show-print"
}
const _hoisted_17 = {
  key: 0,
  class: "table-head-wrapper"
}
const _hoisted_18 = {
  class: "time",
  rowspan: "2"
}
const _hoisted_19 = ["colspan"]
const _hoisted_20 = {
  key: 1,
  class: "table-head-wrapper"
}
const _hoisted_21 = {
  class: "time",
  rowspan: "2"
}
const _hoisted_22 = ["colspan"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "time" }
const _hoisted_25 = { class: "time" }
const _hoisted_26 = {
  key: 2,
  class: "show-print"
}
const _hoisted_27 = { class: "summary-time-fix" }
const _hoisted_28 = { class: "time" }
const _hoisted_29 = { class: "time" }
const _hoisted_30 = { class: "time" }

import { onMounted, onUnmounted, watch, computed, ref } from 'vue'
import $ from 'jquery'
import moment, { Moment } from 'moment'
import { useRoute, useRouter } from 'vue-router'
import { chunk, times, camelCase, flatten } from 'lodash'
import ControllPanel from '@/components/common/ControllPanel.vue'
import DataTable from '@/components/reports/DataTable.vue'
import DataRuiTable from '@/components/reports/DataRuiTable.vue'
import DataRuiHeader from '@/components/reports/DataRuiHeader.vue'
import DataWeatherHeader from '@/components/reports/DataWeatherHeader.vue'
import WdCountRateTable from '@/components/reports/WdCountRateTable.vue'
import Selector from '@/components/reports/Selector.vue'
import StationSelector from '@/components/common/StationSelector.vue'
import { RESOLUTIONS } from '@/components/common/ResolutionSelector.vue'
import { useReportData } from '@/stores/reportDataStore'
import { useSummaryStore } from '@/stores/summaryStore'
import { useGlobalStore } from '@/stores/globalStore'
import {
  HEADER_SIZE,
  HEADER_MARGIN,
  CONTROLLER_SIZE,
  TABLE_MARGIN,
  TABLE_HEADER_SIZE,
  windDirectionLabel,
} from '@/lib/constants'
import CsvDownloader, { CsvData } from '@/lib/CsvDownloader'
import { useInitDataStore } from '@/stores/initDataStore'
import { HistoryItem } from '@/models/History'
import { DefinitionInfoReportsItem, DefinitionInfoWeatherItemHeader } from '@/models/initData/DefinitionInfo'
import { format } from '@/lib/formatter'
import { setTitle as resetTitle } from '@/router/index'
import { WIND_DIRECTION_LABELS } from '@/lib/constants'

type Row = {
  time: string
  values: (string | undefined)[]
}

/** 取得時間の方向. */
enum TimeDirection {
  /** 過去. */
  PAST,
  /** 未来. */
  FUTURE,
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const REPORT_TYPES = {
  RAIN_HOURY: 'rain_hourly',
  RAIN_DAILY: 'rain_daily',
  RAIN_MONTHLY: 'rain_monthly',
  RAIN_YEARLY: 'rain_yearly',
  WATER_MINUTELY: 'water_minutely',
  WATER_HOURY: 'water_hourly',
  WATER_DAILY: 'water_daily',
  WATER_MONTHLY: 'water_monthly',
  WATER_YEARLY: 'water_yearly',
  RAIN_RUISEKI: 'rain_rui',
  WEATHER_MINUTELY: 'weather_minutely',
  WEATHER_HOURLY: 'weather_hourly',
  WEATHER_DAILY: 'weather_daily',
  WEATHER_MONTHLY: 'weather_monthly',
  WEATHER_YEARLY: 'weather_yearly',
}

const WEATHER_TYPES = [
  REPORT_TYPES.WEATHER_MINUTELY,
  REPORT_TYPES.WEATHER_HOURLY,
  REPORT_TYPES.WEATHER_DAILY,
  REPORT_TYPES.WEATHER_MONTHLY,
  REPORT_TYPES.WEATHER_YEARLY,
]

const REPORT_TYPE_LABELS = {
  [REPORT_TYPES.RAIN_HOURY]: '雨量時報帳票',
  [REPORT_TYPES.RAIN_DAILY]: '雨量日報帳票',
  [REPORT_TYPES.RAIN_MONTHLY]: '雨量月報帳票',
  [REPORT_TYPES.RAIN_YEARLY]: '雨量年報帳票',
  [REPORT_TYPES.WATER_MINUTELY]: '水位分報帳票',
  [REPORT_TYPES.WATER_HOURY]: '水位時報帳票',
  [REPORT_TYPES.WATER_DAILY]: '水位日報帳票',
  [REPORT_TYPES.WATER_MONTHLY]: '水位月報帳票',
  [REPORT_TYPES.WATER_YEARLY]: '水位年報帳票',
  [REPORT_TYPES.RAIN_RUISEKI]: '累計雨量',
  [REPORT_TYPES.WEATHER_MINUTELY]: '気象分報',
  [REPORT_TYPES.WEATHER_HOURLY]: '気象時報',
  [REPORT_TYPES.WEATHER_DAILY]: '気象日報',
  [REPORT_TYPES.WEATHER_MONTHLY]: '気象月報',
  [REPORT_TYPES.WEATHER_YEARLY]: '気象年報',
}

const REPORT_TYPE_RESOLUTION = {
  [REPORT_TYPES.RAIN_HOURY]: 'hour',
  [REPORT_TYPES.RAIN_DAILY]: 'day',
  [REPORT_TYPES.RAIN_MONTHLY]: 'month',
  [REPORT_TYPES.RAIN_YEARLY]: 'year',
  [REPORT_TYPES.RAIN_RUISEKI]: 'rui',
  [REPORT_TYPES.WATER_MINUTELY]: 'minute',
  [REPORT_TYPES.WATER_HOURY]: 'hour',
  [REPORT_TYPES.WATER_DAILY]: 'day',
  [REPORT_TYPES.WATER_MONTHLY]: 'month',
  [REPORT_TYPES.WATER_YEARLY]: 'year',
  [REPORT_TYPES.WEATHER_MINUTELY]: 'minute',
  [REPORT_TYPES.WEATHER_HOURLY]: 'hour',
  [REPORT_TYPES.WEATHER_DAILY]: 'day',
  [REPORT_TYPES.WEATHER_MONTHLY]: 'month',
  [REPORT_TYPES.WEATHER_YEARLY]: 'year',
}

const DATE_OPTIONS = {
  minute: {
    num: 60,
    span: 60,
    format: 'HH:mm',
  },
  hour: {
    num: 6 * 24,
    span: 60 * 10,
    format: 'HH:mm',
  },
  day: {
    num: 24,
    span: 60 * 60,
    format: 'HH:mm',
  },
  month: {
    num: 30,
    span: 60 * 60 * 24,
    format: 'DD',
  },
  year: {
    num: 12,
    span: 60 * 60 * 24 * 31,
    format: 'MM',
  },
} as const

const SHOW_SUMMERY_RESOLUTIONS = ['day', 'month', 'year']

const CELL_WIDTH = 150
const TIME_CELL_WIDTH = 80

const PRINT_ROW_SIZE = 36
const PRINT_COL_SIZE = 9

const WATER_AP_FIELDS = ['waterLevelAp', 'avgWaterLevelAp', 'maxWaterLevelAp', 'minWaterLevelAp']
const WEATHER_DIRECTION_FIELD_KEYS = ['moveWdMin10', 'moveMaxWdMin10', 'maxMoveMaxWdMin10', 'avgMoveWdMin10']

const route = useRoute()
const router = useRouter()
const globalStore = useGlobalStore()
const initDataStore = useInitDataStore()
const reportData = useReportData()
const summaryStore = useSummaryStore()

const queryDate = route.query.date as string

const reportTypeItem = ref<DefinitionInfoReportsItem>()
const date = ref<Date>(moment(queryDate || new Date()).toDate())
const tableBodySize = ref<number>()
const spShowSummary = ref<boolean>(false)
const headers = ref<string[]>([])
const loading = ref<boolean>(true)
const targetHour4Minutely = ref<number>(moment().hour() + 1)
const otherRows4Minutely = ref<Row[]>([])
const defaults = ref<{
  tabIndex: number
  listItemIndex: number
  itemIndex: number
}>()
const timeDirection = ref<TimeDirection>(TimeDirection.FUTURE)
const mounting = ref<boolean>(false)

const weatherHeaders = computed(() => initDataStore.initData.definitionInfo.reports.weather[resolution.value].header)

const reportType = computed(() => reportTypeItem.value?.event[0].args.args[0].type)
const defaultAreaCode = computed(() => {
  return initDataStore.areaList[0].id
})

const showSummary = computed(() => {
  return SHOW_SUMMERY_RESOLUTIONS.includes(resolution.value)
})

const definitionInfo = computed(() => {
  if (isRain.value) {
    return initDataStore.definitionInfoRain(resolution.value)
  } else if (isWeather.value) {
    return initDataStore.definitionInfoWeather(resolution.value)
  } else {
    return initDataStore.definitionInfoWater(resolution.value)
  }
})

const definitionStations = computed(() => {
  if (!definitionInfo.value) {
    return
  }

  return {
    stationIds: definitionInfo.value.items.map(item => item.stationId),
    additionalRows: definitionInfo.value.additionalRow || [],
  }
})

const stationType = computed(() => {
  return isWeather.value ? '' : isRain.value ? 'rain' : 'water'
})

const isRui = computed(() => {
  return reportType.value === REPORT_TYPES.RAIN_RUISEKI
})

const isWeather = computed(() => {
  return WEATHER_TYPES.includes(reportType.value as string)
})

const isRain = computed(() => {
  const type = reportType.value || ''

  return type.includes('rain')
})

const selectRange = computed((): Range => {
  const targetDate = moment(date.value as Date) as Moment
  const format = 'YYYY-MM-DD HH:mm:ss'

  if (resolution.value === 'weather') {
    return {
      startTime: moment(targetDate).startOf('day').format(format),
      endTime: moment(targetDate).endOf('day').format(format),
    } as Range
  } else if (resolution.value === 'rui') {
    return {
      startTime: moment(targetDate).startOf('month').format(format),
      endTime: moment(targetDate).endOf('month').format(format),
    } as Range
  } else if (resolution.value === 'minute') {
    return {
      startTime: moment(targetDate)
        .startOf('day')
        .add(targetHour4Minutely.value - 1, 'hour')
        .format(format),
      endTime: moment(targetDate).startOf('day').add(targetHour4Minutely.value, 'hour').format(format),
    } as Range
  } else if (resolution.value === 'hour' || resolution.value === 'day') {
    return {
      startTime: moment(targetDate).startOf('day').format(format),
      endTime: moment(targetDate).add(1, 'day').startOf('day').format(format),
    } as Range
  } else if (resolution.value === 'month') {
    return {
      startTime: moment(targetDate).startOf('month').format(format),
      endTime: moment(targetDate).startOf('month').add(1, 'month').format(format),
    } as Range
  } else {
    return {
      startTime: moment(targetDate).startOf('year').format(format),
      endTime: moment(targetDate).startOf('year').add(1, 'year').format(format),
    } as Range
  }
})

const headerUnits = computed(() => {
  const fields = definitionInfo.value?.items[0].fieldId || []

  return fields.map(key => {
    const field = initDataStore.fieldListItem(camelCase(key))
    const listName = field?.listNames[camelCase(reportType.value)]

    return {
      key,
      name: listName || field?.name,
      unit: field?.unit,
    }
  })
})

const stationId = computed(() => {
  const weatherStationId = reportTypeItem.value?.event[0].args.args[0].stationId

  return weatherStationId || globalStore.currentStation?.stationId
})

const currentArea = computed(() => {
  return globalStore.currentArea || initDataStore.findArea(defaultAreaCode.value)
})

const summaryWrapperHeight = computed(() => {
  if (!showSummary.value) {
    return 0
  }

  const rowLength = definitionInfo.value?.definitionSummary?.length || 0
  const height = rowLength * 30 + 1

  return height
})

const summaryWrapperStyle = computed(() => {
  return `height: ${summaryWrapperHeight.value}px`
})

const disabledCsv = computed(() => {
  return initDataStore.definitionInfoReports.disabledCsv
})

const disabledPdf = computed(() => {
  return initDataStore.definitionInfoReports.disabledPdf
})

const fetch = async (loadingShows = true) => {
  if (loadingShows) {
    loading.value = true
  }

  const DO_WHILE_CONDITION = false
  do {
    if (reportType.value === undefined || !currentArea.value) {
      break
    }

    const stations = currentArea.value.stations()
    const stationIds = stations.map(s => s.stationId)
    const type = REPORT_TYPE_RESOLUTION[reportType.value as string]
    const range = selectRange.value

    if (isRui.value) {
      if (!stationId.value) {
        break
      }
      await reportData.fetchRui(stationId.value, range)
    } else if (isWeather.value) {
      if (!stationId.value) {
        break
      }
      await reportData.fetchWeather(stationId.value, weatherFields.value, type, range)
    } else {
      const target = headerUnits.value.map(v => v.key)

      await reportData.fetch(stationIds, type, range, target).then(setHeaders)
    }

    if (showSummary.value) {
      const countKeys = ['move_wd_min_10_count_rate', 'move_wd_min_10_of_month_count_rate']
      const target = isWeather.value
        ? [...weatherSummaryFields.value, ...countKeys]
        : definitionInfo.value?.items[0].summaryFieldId || []

      await summaryStore.fetchAll(stationIds, type, range, target)
    }
  } while (DO_WHILE_CONDITION)

  if (loadingShows) {
    loading.value = false
  }
}

const handleChangeReportType = (item: DefinitionInfoReportsItem) => {
  reportTypeItem.value = item
  init4Minutely()
  const dateStr = moment(date.value as Date).format('YYYY-MM-DD HH:mm:ss')
  const type = reportType.value

  router.push(`/reports?type=${type}&date=${dateStr}`)
}

const handleChangeDate = (d: Date) => {
  if (!mounting.value) {
    init4Minutely()
  }
  const dateStr = moment(d).format('YYYY-MM-DD HH:mm:ss')

  router.push(`/reports?type=${reportType.value}&date=${dateStr}`)
}

const rows = computed(() => {
  const results = [] as Row[]
  const dateOption = DATE_OPTIONS[resolution.value as keyof typeof DATE_OPTIONS]

  if (!dateOption) {
    return []
  }

  const num = resolution.value === 'month' ? moment(date.value).daysInMonth() : dateOption.num
  const startDate =
    resolution.value === 'year'
      ? moment(date.value).startOf('year')
      : resolution.value === 'month'
      ? moment(date.value).startOf('month')
      : moment(date.value).startOf('day')
  const span = dateOption.span
  const format = dateOption.format

  times(num, index => {
    const offset = ['month', 'year'].includes(resolution.value) ? 0 : 1
    const time = moment(startDate)
      .add(
        span * (index + offset) + (resolution.value === 'minute' ? (targetHour4Minutely.value - 1) * 60 * 60 : 0),
        'second'
      )
      .format(format)
    const row = {
      time,
      values: [] as string[],
    } as Row

    sequencialStationIds.value.forEach(stationId => {
      const stationValues = reportData.data[stationId]
      const station = initDataStore.findStation(stationId)

      if (!stationValues) {
        return
      }
      const target = stationValues.find(item => {
        const baseTime =
          resolution.value === 'month' // 月報の場合API取得データのtimeが1日ずれている
            ? moment(item.time).add(-1, 'day')
            : resolution.value === 'year' // 年報の場合API取得データのtimeが1月ずれている
            ? moment(item.time).add(-1, 'month')
            : moment(item.time)

        return baseTime.format(format) === time
      })

      headerUnits.value.forEach(unit => {
        if (target) {
          const key = camelCase(unit.key)
          const fieldListItem = initDataStore.fieldListItem(key)
          let value = target[key as keyof HistoryItem] as number

          if (WATER_AP_FIELDS.includes(key)) {
            const ap = station?.ap
            const valueKey = key.replace('Ap', '') as keyof HistoryItem

            if (ap !== undefined) {
              value = ap + (target[valueKey] as number)
            }
          }

          if (value !== undefined && value !== null) {
            row.values.push(value.toFixed(fieldListItem.decimal))
          } else {
            row.values.push(undefined)
          }
        } else {
          row.values.push(undefined)
        }
      })
    })

    results.push(row)
  })

  return results
})

const weatherFields = computed(() => {
  return initDataStore.initData.definitionInfo.reports.weather[resolution.value].items[0].fieldId
})

const weatherSummaryFields = computed(() => {
  return initDataStore.initData.definitionInfo.reports.weather[resolution.value].items[0].summaryFieldId
})

const weatherRows = computed(() => {
  const rows = [] as Row[]
  const dateOption = DATE_OPTIONS[resolution.value as keyof typeof DATE_OPTIONS]
  const num = resolution.value === 'month' ? moment(date.value).daysInMonth() : dateOption.num
  const startDate =
    resolution.value === 'year'
      ? moment(date.value).startOf('year')
      : resolution.value === 'month'
      ? moment(date.value).startOf('month')
      : moment(date.value).startOf('day')
  const span = dateOption.span
  const format = dateOption.format

  times(num, index => {
    const offset = ['month', 'year'].includes(resolution.value) ? 0 : 1
    const time = moment(startDate)
      .add(
        span * (index + offset) + (resolution.value === 'minute' ? (targetHour4Minutely.value - 1) * 60 * 60 : 0),
        'second'
      )
      .format(format)
    const row = {
      time,
      values: [] as string[],
    } as Row

    const target = reportData.dataWeather.find(item => {
      const baseTime =
        resolution.value === 'month' // 月報の場合API取得データのtimeが1日ずれている
          ? moment(item.time).add(-1, 'day')
          : resolution.value === 'year' // 年報の場合API取得データのtimeが1月ずれている
          ? moment(item.time).add(-1, 'month')
          : moment(item.time)

      return baseTime.format(format) === time
    })

    weatherFields.value.forEach(_field => {
      if (target) {
        const field = camelCase(_field)
        const value = target[field] as number

        if (value !== undefined && value !== null) {
          if (WEATHER_DIRECTION_FIELD_KEYS.includes(field)) {
            row.values.push(windDirectionLabel(value))
          } else {
            row.values.push(value.toFixed(1))
          }
        } else {
          row.values.push(undefined)
        }
      } else {
        row.values.push(undefined)
      }
    })

    rows.push(row)
  })
  return rows
})

const displayRows = computed(() => {
  let mainRows: Row[] = isWeather.value ? weatherRows.value : rows.value

  if (resolution.value === 'minute') {
    // 分報の場合
    if (isToday.value) {
      // 表示日が本日の場合
      // 未来時間を24:00まで空欄で埋める
      return [...mainRows, ...otherRows4Minutely.value, ...emptyRows4Minutely.value]
    } else {
      return timeDirection.value === TimeDirection.FUTURE
        ? [...otherRows4Minutely.value, ...mainRows] // 未来時間を取得した場合
        : [...mainRows, ...otherRows4Minutely.value] // 過去時間を取得した場合
    }
  } else {
    return mainRows
  }
})

const emptyRows4Minutely = computed(() => {
  const result: Row[] = []

  let targetRows: Row[] = isWeather.value ? weatherRows.value : rows.value
  for (
    const time = otherRows4Minutely.value.length
      ? moment(`2000-01-01 ${otherRows4Minutely.value[otherRows4Minutely.value.length - 1].time}:00`)
      : moment(`2000-01-01 ${targetRows[targetRows.length - 1].time}:00`);
    !(time.hour() === 0 && time.minute() === 1);
    time.add(1, 'minute')
  ) {
    result.push({ time: time.format('HH:mm'), values: new Array<string>(targetRows[0].values.length) })
  }

  return result
})

const currentStations = computed(() => {
  return currentArea.value ? currentArea.value.stations() : initDataStore.initData.stationList
})

const sequencialStationIds = computed(() => {
  const currentStationIds = currentStations.value.map(c => c.stationId)

  return definitionStations.value?.stationIds.filter(stationId => currentStationIds.includes(stationId)) || []
})

const additionalRows = computed(() => {
  if (!definitionStations.value) {
    return []
  }
  const indexes = [] as number[]
  definitionStations.value.stationIds.forEach((stationId, index) => {
    if (sequencialStationIds.value.includes(stationId)) {
      indexes.push(index)
    }
  })
  return definitionStations.value.additionalRows.filter((_, index) => indexes.includes(index))
})

const chunkedSequencialStationIds = computed(() => {
  return chunk(sequencialStationIds.value, printColSize.value / headerUnits.value.length)
})

const setHeaders = () => {
  headers.value =
    sequencialStationIds.value.map(stationId => {
      const target = initDataStore.initData.stationList.find(station => station.stationId === stationId)

      return target ? target.name : ''
    }) || []
}

const resolution = computed(() => {
  return REPORT_TYPE_RESOLUTION[reportType.value]
})

const printHeader = computed(() => {
  const reportTypeLabel = REPORT_TYPE_LABELS[reportType.value]
  const resolution = REPORT_TYPE_RESOLUTION[reportType.value]
  const areaName = globalStore.isIchinomiya ? '' : globalStore.currentArea?.name
  const format = isRui.value
    ? 'YYYY年MM月'
    : resolution === 'year'
    ? 'YYYY年'
    : resolution === 'month'
    ? 'YYYY年MM月'
    : 'YYYY年MM月DD日'
  const dateStr = moment(date.value as Date).format('YYYY-MM-DD')
  const dateLabel = moment(dateStr).format(format)

  return `${reportTypeLabel} ${areaName ?? ''} ${dateLabel}`
})

const currentStationName = computed(() => {
  return globalStore.currentStation?.name ?? ''
})

const downloadCsv = () => {
  const dateFormat =
    resolution.value === 'minute' || resolution.value === 'hour' || resolution.value === 'day'
      ? 'YYYY-MM-DD'
      : resolution.value === 'month' || resolution.value === 'rui'
      ? 'YYYY-MM'
      : 'YYYY'
  const dateStr = moment(date.value as Date).format(dateFormat)
  const areaName = globalStore.currentArea?.name
  const fileName = `${dateStr}_${reportType.value}_${areaName}.csv`

  isWeather.value
    ? downloadWeatherCsv(fileName)
    : isRui.value
    ? downloadRuisekiCsv(fileName)
    : downloadNormalCsv(fileName)
}

const downloadNormalCsv = async (fileName: string) => {
  if (!(await fetchAllDataInMinutely())) {
    return
  }

  const csvHeadersPrev = [''] as string[]
  const csvHeaders = [''] as string[]
  const csvHeadersNext = [timeLabel.value] as string[]

  headers.value.forEach((header, index) => {
    headerUnits.value.forEach(unit => {
      csvHeadersPrev.push(additionalRows.value[index])
      csvHeaders.push(header)
      csvHeadersNext.push(unit.name)
    })
  })

  const csvData = [csvHeadersPrev, csvHeaders, csvHeadersNext] as CsvData

  displayRows.value.forEach(row => {
    const time = row.time === '00:00' ? '24:00' : row.time
    csvData.push([time, ...row.values])
  })

  if ((isRain.value || !isWeather.value) && definitionInfo && definitionInfo.value?.definitionSummary) {
    csvData.push([])
    definitionInfo.value?.definitionSummary.forEach(info => {
      let addRow = [info.title]

      summaryStore.getRows(definitionInfo.value, info, sequencialStationIds.value).forEach(row => {
        addRow.push(row?.value?.toFixed ? row?.value?.toFixed(initDataStore.decimal(row.key)) : row?.value)
      })

      csvData.push(addRow)
    })
  }

  CsvDownloader.download(csvData, fileName)
}

const downloadRuisekiCsv = (fileName: string) => {
  const csvHeaders = globalStore.isIchinomiya
    ? ['降り始め', '起時', '総雨量(mm)']
    : ['降り始め', '降り終わり', '10分間最大雨量(mm)', '起時', '1時間最大雨量(mm)', '起時', '総雨量(mm)']

  const csvData = [csvHeaders] as CsvData

  reportData.dataRui.forEach(row => {
    const row0 = format(row.startTime, 'YYYY年MM月DD日 HH:mm')
    const row1 = row.finished ? format(row.endTime, 'YYYY年MM月DD日 HH:mm') : ''
    const row2 = row.maxMoveRainMin10?.toFixed(1)
    const row3 = format(row.maxMoveRainMin10Time, 'YYYY年MM月DD日 HH:mm')
    const row4 = row.maxMoveRainMin60?.toFixed(1)
    const row5 = format(row.maxMoveRainMin60Time, 'YYYY年MM月DD日 HH:mm')
    const row6 = row.rainRui?.toFixed(1)

    globalStore.isIchinomiya
      ? csvData.push([row0, row1, row6])
      : csvData.push([row0, row1, row2, row3, row4, row5, row6])
  })

  CsvDownloader.download(csvData, fileName)
}

const downloadWeatherCsv = async (fileName: string) => {
  if (!(await fetchAllDataInMinutely())) {
    return
  }

  const csvHeaders = [timeLabel.value]
  const headers = initDataStore.initData.definitionInfo.reports.weather[resolution.value].header

  headers.forEach(h => {
    h.items.forEach(item => {
      let label = `${h.name}${item.name}`
      if (item.unit) {
        label += `(${item.unit})`
      }
      csvHeaders.push(label)
    })
  })

  const csvData = [csvHeaders] as CsvData

  displayRows.value.forEach(row => {
    const time = row.time === '00:00' ? '24:00' : row.time
    csvData.push([time, ...row.values])
  })

  if (isWeather.value && stationId.value && definitionInfo && definitionInfo.value?.definitionSummary) {
    csvData.push([])
    summaryStore.getWeatherRows(stationId.value, resolution.value).forEach(info => {
      csvData.push([info.title, ...info.values])
    })
  }

  if (isWeather.value && stationId.value) {
    csvData.push([])

    const WIND_DIRECTION_SEQ = [
      '16', // 北
      '01', // 北北東
      '02', // 北東
      '03', // 東北東
      '04', // 東
      '05', // 東南東
      '06', // 南東
      '07', // 南南東
      '08', // 南
      '09', // 南南西
      '10', // 南西
      '11', // 西南西
      '12', // 西
      '13', // 西北西
      '14', // 北西
      '15', // 北北西
      '00', // 静穏
    ]

    const headers = computed(() => {
      return WIND_DIRECTION_SEQ.map(key => WIND_DIRECTION_LABELS[key as keyof typeof WIND_DIRECTION_LABELS])
    })

    const ratios = computed(() => {
      return WIND_DIRECTION_SEQ.map(key => {
        const index = Number(key)
        const value = summaryStore.getWdCountRate(stationId.value, resolution.value)[index]

        if (value === undefined) {
          return ''
        }

        return (value * 100).toFixed(1)
      })
    })

    csvData.push(['風向頻度', ...headers.value])
    csvData.push(['%', ...ratios.value])
  }

  CsvDownloader.download(csvData, fileName)
}

const print = async () => {
  if (!(await fetchAllDataInMinutely())) {
    return
  }

  window.print()
}

const chunkedHeaderForPrint = computed(() => {
  const chunkSize = printColSize.value / headerUnits.value.length

  return chunk(headers.value, chunkSize).map(chunked => {
    return chunked.concat(Array.from(Array(chunkSize - chunked.length)))
  })
})

const chunkedWeatherHeaderForPrint = computed(() => {
  const result: (DefinitionInfoWeatherItemHeader | undefined)[][] = [[]]

  let colCount = 0
  for (const header of weatherHeaders.value) {
    if (printColSize.value < colCount + header.items.length) {
      // このヘッダを追加したらはみ出してしまう場合
      // printColSizeをオーバーしないギリギリまで追加
      const items = []
      for (let i = 0; i < printColSize.value - colCount; i++) {
        items.push(header.items[i])
      }
      result[result.length - 1].push({
        ...header,
        items: items,
      })
      // はみ出た分を次の行に追加
      const nextRow = []
      const nextRowItems = []
      for (let i = printColSize.value - colCount; i < header.items.length; i++) {
        nextRowItems.push(header.items[i])
      }
      nextRow.push({
        ...header,
        items: nextRowItems,
      })
      result.push(nextRow)
      // 次の行へ
      colCount = 0
    } else {
      colCount += header.items.length
      result[result.length - 1].push(header)
    }
  }

  // 足りないカラムを空白カラムで補う
  const itemsCountInLastHeaders = result[result.length - 1].reduce(
    (sum, header) => sum + (header?.items.length ?? 1),
    0
  )
  if (itemsCountInLastHeaders < printColSize.value) {
    result[result.length - 1].push(...new Array<undefined>(printColSize.value - itemsCountInLastHeaders))
  }

  return result
})

const chunkedWeatherHeaderItemsForPrint = computed(() => {
  return chunkedWeatherHeaderForPrint.value.map(headers => flatten(headers.map(header => header?.items)))
})

const printColSize = computed(() => {
  if (isWeather.value) {
    return PRINT_COL_SIZE
  }

  return Math.floor(PRINT_COL_SIZE / headerUnits.value.length) * headerUnits.value.length
})

const chunkedDataForPrint = computed(() => {
  return chunk(displayRows.value, PRINT_ROW_SIZE).map(chunkedRows => {
    const hChunk = [] as Row[][]

    chunkedRows.forEach(row => {
      chunk(row.values, printColSize.value).forEach((chunkedCols, index) => {
        if (hChunk[index] === undefined) {
          hChunk[index] = []
        }
        const spaces = Array.from(Array(printColSize.value - chunkedCols.length))
        const values = chunkedCols.concat(spaces)

        hChunk[index].push({ time: row.time, values })
      })
    })

    return hChunk
  })
})

const getTableBodySize = (h: number) => {
  let bufferSize =
    HEADER_SIZE +
    HEADER_MARGIN +
    CONTROLLER_SIZE +
    TABLE_MARGIN * 2 +
    TABLE_HEADER_SIZE +
    (showSummary.value ? summaryWrapperHeight.value : 0) +
    (showSummary.value && isWeather.value ? 100 : 0)

  if (globalStore.isSP) {
    bufferSize += 60
  }

  return h - bufferSize
}

const tableBodyStyle = () => {
  if (!tableBodySize.value) {
    return {}
  }

  if (window.innerHeight < 600) {
    tableBodySize.value = getTableBodySize(600)
  }

  return {
    height: `${tableBodySize.value}px`,
  }
}

const tableWidth = computed(() => {
  const width =
    (isWeather.value
      ? weatherFields.value.length * CELL_WIDTH
      : headers.value.length * headerUnits.value.length * CELL_WIDTH) +
    TIME_CELL_WIDTH +
    1

  return `width: ${width}px`
})

const printTableWidth = computed(() => {
  const width = printColSize.value * CELL_WIDTH + TIME_CELL_WIDTH + 1

  return `width: ${width}px`
})

const isToday = computed(() => moment(date.value).diff(moment(), 'days') === 0)

const handleResize = () => {
  const h = window.innerHeight

  tableBodySize.value = getTableBodySize(h)
}

handleResize()

const handleShowSummary = () => {
  spShowSummary.value = true
}

const handleHideSummary = () => {
  spShowSummary.value = false
}

const timeLabel = computed(() => {
  return definitionInfo.value?.headerTime
})

const handleScrollBody = () => {
  const $timeFix = $('.time-fix')
  const $additionalHeader = $('#tableAdditionalHead')
  const $header = $('#tableHead')
  const $summary = $('.table-summary')
  const $tableBodyWrapper = $('.table-body-wrapper')
  const left = $tableBodyWrapper.scrollLeft()
  const top = $tableBodyWrapper.scrollTop() ?? 0

  $timeFix.css('left', `${left}px`)
  $additionalHeader.css('left', `-${left}px`)
  $header.css('left', `-${left}px`)
  $summary.css('left', `-${left}px`)

  if (resolution.value === 'minute') {
    // 分報の場合、スクロールでデータを追加取得する
    if (!isToday.value && $tableBodyWrapper[0].scrollHeight - ($tableBodyWrapper[0].clientHeight + top) === 0) {
      getNextHourData()
    } else if (top === 0) {
      getPrevHourData().then((result: boolean) => {
        if (result) {
          $tableBodyWrapper[0].scrollTop = $tableBodyWrapper.find('td')[0].offsetHeight * rows.value.length
        }
      })
    }
  }
}

const getPrevHourData = async (): Promise<boolean> => {
  const firstHour = getHourNumericFromTimeString(displayRows.value[0].time)
  if (firstHour !== 0) {
    if (timeDirection.value === TimeDirection.FUTURE) {
      isWeather.value
        ? otherRows4Minutely.value.push(...weatherRows.value)
        : otherRows4Minutely.value.push(...rows.value)
    } else {
      isWeather.value
        ? otherRows4Minutely.value.unshift(...weatherRows.value)
        : otherRows4Minutely.value.unshift(...rows.value)
    }
    timeDirection.value = TimeDirection.PAST
    targetHour4Minutely.value = firstHour
    await fetch(false)

    return true
  }
  return false
}

const getNextHourData = async (): Promise<boolean> => {
  const latestHour = getHourNumericFromTimeString(displayRows.value[displayRows.value.length - 1].time)
  if (latestHour !== 0) {
    if (timeDirection.value === TimeDirection.FUTURE) {
      isWeather.value
        ? otherRows4Minutely.value.push(...weatherRows.value)
        : otherRows4Minutely.value.push(...rows.value)
    } else {
      isWeather.value
        ? otherRows4Minutely.value.unshift(...weatherRows.value)
        : otherRows4Minutely.value.unshift(...rows.value)
    }
    timeDirection.value = TimeDirection.FUTURE
    targetHour4Minutely.value = latestHour + 1
    await fetch(false)

    return true
  }
  return false
}

const fetchAllDataInMinutely = async (): Promise<boolean> => {
  if (resolution.value !== 'minute') {
    return true
  }
  if (displayRows.value.length > 24 * 60 || confirm('処理に時間がかかりますが実行しますか？')) {
    loading.value = true
    // 過去のデータ取得
    while (getHourNumericFromTimeString(displayRows.value[0].time) !== 0) {
      await getPrevHourData()
    }
    // 未来のデータ取得
    while (getHourNumericFromTimeString(displayRows.value[displayRows.value.length - 1].time) !== 0) {
      await getNextHourData()
    }
    loading.value = false
  } else {
    return false
  }
  return true
}

/**
 * 水位分報の初期処理.
 */
const init4Minutely = () => {
  targetHour4Minutely.value = moment().hour() + 1
  otherRows4Minutely.value.splice(0)
}

// 印刷時のファイル名のためtitleを設定
const setTitle = () => {
  window.document.title = printHeader.value
}

const setReportTypeItem = () => {
  const queryReportType = route.query.type as string

  initDataStore.initData.definitionInfo.reports.common.listItems.items.forEach((item1, index1) => {
    item1.items.forEach((item2, index2) => {
      item2.items.forEach((item, index3) => {
        if (item.event[0].args.args[0].type === queryReportType) {
          reportTypeItem.value = item
          defaults.value = {
            tabIndex: index1,
            listItemIndex: index2,
            itemIndex: index3,
          }
        }
      })
    })
  })
}

/**
 * hh:mm形式の文字列から時間を数値で取得します.
 *
 * @param { string } hhmm hh:mm形式の時間文字列.
 * @returns { number } 時間.
 */
const getHourNumericFromTimeString = (hhmm: string): number => {
  return moment(`2000-01-01 ${hhmm}:00`).hour()
}

onMounted(async () => {
  mounting.value = true

  const $tableBodyWrapper = $('.table-body-wrapper')
  const queryReportType = route.query.type as string

  window.addEventListener('resize', handleResize)
  window.addEventListener('beforeprint', setTitle)
  window.addEventListener('afterprint', () => resetTitle(route))
  $tableBodyWrapper.on('scroll', handleScrollBody)
  $tableBodyWrapper.on('touchmove', handleScrollBody)

  // 初期タイプ選択
  if (queryReportType === undefined) {
    defaults.value = {
      tabIndex: 0,
      listItemIndex: 0,
      itemIndex: 0,
    }
    reportTypeItem.value = initDataStore.initData.definitionInfo.reports.common.listItems.items[0].items[0].items[0]
  } else {
    setReportTypeItem()
  }

  date.value = moment(route.query.date as string).toDate()

  await fetch()

  mounting.value = false
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
  window.removeEventListener('beforeprint', setTitle)
  window.removeEventListener('afterprint', () => resetTitle(route))
})

watch(() => globalStore.currentStation, fetch)
watch(() => globalStore.currentArea, fetch)

watch(
  () => reportType.value,
  () => {
    handleResize()
    spShowSummary.value = false
    $('.table-body-wrapper').scrollLeft(0)
    fetch()
  }
)

watch(
  () => date.value,
  () => {
    handleResize()
    spShowSummary.value = false
    fetch()
  }
)

watch(
  () => route.query.date,
  () => {
    const dateStr = route.query.date as string
    date.value = moment(dateStr).toDate()
  }
)

watch(
  () => route.query.type,
  () => {
    setReportTypeItem()
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createVNode(ControllPanel, {
        onChangeDate: handleChangeDate,
        onShowSummary: handleShowSummary,
        onHideSummary: handleHideSummary,
        "default-date": date.value,
        "is-show-summary": spShowSummary.value,
        "show-resolution": false,
        "default-resolution": _unref(resolution) === 'minute' ? _unref(RESOLUTIONS).DAY : _unref(resolution)
      }, {
        left: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(Selector, {
              onSelect: handleChangeReportType,
              defaults: defaults.value
            }, null, 8, ["defaults"]),
            _createVNode(StationSelector, {
              "station-type": _unref(stationType),
              "show-stations": _unref(isRui)
            }, null, 8, ["station-type", "show-stations"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            (!_unref(disabledCsv))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: downloadCsv,
                  class: "actions-item with-icon btn-csv"
                }, "CSV"))
              : _createCommentVNode("", true),
            (!_unref(disabledPdf))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onClick: print,
                  class: "actions-item with-icon btn-print"
                }, "印刷"))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["default-date", "is-show-summary", "default-resolution"]),
      (_unref(isRui))
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            style: _normalizeStyle(_unref(printTableWidth)),
            class: "print-header show-print"
          }, _toDisplayString(_unref(printHeader)) + " " + _toDisplayString(_unref(currentStationName)), 5))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (!_unref(isRain) && _unref(additionalRows) && _unref(additionalRows).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("table", {
                  style: _normalizeStyle(_unref(tableWidth)),
                  id: "tableAdditionalHead",
                  class: "table-head hide-print additional-table"
                }, [
                  _createElementVNode("tr", null, [
                    _hoisted_10,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(additionalRows), (header, index) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: index,
                        colspan: _unref(headerUnits).length
                      }, _toDisplayString(header), 9, _hoisted_11))
                    }), 128))
                  ])
                ], 4)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass([_unref(isRui) ? 'rui' : '', "table-head-wrapper"])
          }, [
            (!_unref(isRui) && !_unref(isWeather))
              ? (_openBlock(), _createElementBlock("table", {
                  key: 0,
                  style: _normalizeStyle(_unref(tableWidth)),
                  id: "tableHead",
                  class: "table-head hide-print"
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(timeLabel)), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers.value, (header, index) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: index,
                        colspan: _unref(headerUnits).length
                      }, _toDisplayString(header), 9, _hoisted_13))
                    }), 128))
                  ]),
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers.value.length * _unref(headerUnits).length, (index) => {
                      return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(_unref(headerUnits)[(index - 1) % _unref(headerUnits).length].name), 1))
                    }), 128))
                  ])
                ], 4))
              : _createCommentVNode("", true),
            (_unref(isRui))
              ? (_openBlock(), _createBlock(DataRuiHeader, { key: 1 }))
              : _createCommentVNode("", true),
            (_unref(isWeather))
              ? (_openBlock(), _createBlock(DataWeatherHeader, {
                  key: 2,
                  resolution: _unref(resolution),
                  style: _normalizeStyle(_unref(tableWidth)),
                  class: "hide-print"
                }, null, 8, ["resolution", "style"]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("table", _hoisted_14, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(timeLabel)), 1)
              ])
            ], 512), [
              [_vShow, !_unref(isRui)]
            ])
          ], 2),
          _createElementVNode("div", {
            style: _normalizeStyle(tableBodyStyle()),
            class: "table-body-wrapper hide-print"
          }, [
            (!_unref(isRui) && !_unref(isWeather))
              ? (_openBlock(), _createBlock(DataTable, {
                  key: 0,
                  rows: _unref(displayRows),
                  resolution: _unref(resolution),
                  date: date.value,
                  headerUnits: _unref(headerUnits),
                  style: _normalizeStyle(_unref(tableWidth)),
                  stationIds: _unref(sequencialStationIds)
                }, null, 8, ["rows", "resolution", "date", "headerUnits", "style", "stationIds"]))
              : _createCommentVNode("", true),
            (_unref(isRui))
              ? (_openBlock(), _createBlock(DataRuiTable, {
                  key: 1,
                  data: _unref(reportData).dataRui
                }, null, 8, ["data"]))
              : _createCommentVNode("", true),
            (_unref(isWeather))
              ? (_openBlock(), _createBlock(DataTable, {
                  key: 2,
                  rows: _unref(displayRows),
                  style: _normalizeStyle(_unref(tableWidth))
                }, null, 8, ["rows", "style"]))
              : _createCommentVNode("", true)
          ], 4),
          (!_unref(isRui))
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chunkedDataForPrint), (chunk1, index1) => {
                  return (_openBlock(), _createElementBlock("div", { key: index1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunk1, (rows, index2) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index2,
                        class: _normalizeClass([index1 + index2 > 0 ? 'page-break' : '', "print-page"])
                      }, [
                        _createElementVNode("p", {
                          style: _normalizeStyle(_unref(printTableWidth)),
                          class: "print-header show-print"
                        }, _toDisplayString(_unref(printHeader)), 5),
                        (_unref(isWeather))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createElementVNode("table", {
                                style: _normalizeStyle(_unref(printTableWidth)),
                                id: "tableHead",
                                class: "table-head show-print"
                              }, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(timeLabel)), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chunkedWeatherHeaderForPrint)[index2], (header, index3) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      key: index3,
                                      colspan: header?.items.length ?? 1
                                    }, _toDisplayString(header?.name ?? ''), 9, _hoisted_19))
                                  }), 128))
                                ]),
                                _createElementVNode("tr", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chunkedWeatherHeaderItemsForPrint)[index2], (item, index3) => {
                                    return (_openBlock(), _createElementBlock("td", { key: index3 }, _toDisplayString((item?.name ?? '') + (item && item?.unit !== '' ? `(${item?.unit})` : '')), 1))
                                  }), 128))
                                ])
                              ], 4)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("table", {
                                style: _normalizeStyle(_unref(printTableWidth)),
                                id: "tableHead",
                                class: "table-head show-print"
                              }, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(timeLabel)), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chunkedHeaderForPrint)[index2], (header, index3) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      key: index3,
                                      colspan: _unref(headerUnits).length
                                    }, _toDisplayString(header), 9, _hoisted_22))
                                  }), 128))
                                ]),
                                (_unref(chunkedHeaderForPrint)[index2])
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chunkedHeaderForPrint)[index2].length * _unref(headerUnits).length, (index3) => {
                                        return (_openBlock(), _createElementBlock("td", { key: index3 }, _toDisplayString(_unref(chunkedHeaderForPrint)[index2][Math.floor((index3 - 1) / _unref(headerUnits).length)]
                          ? _unref(headerUnits)[(index3 - 1) % _unref(headerUnits).length].name
                          : ''), 1))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 4)
                            ])),
                        _createVNode(DataTable, {
                          rows: rows,
                          resolution: _unref(resolution),
                          date: date.value,
                          headerUnits: _unref(headerUnits),
                          style: _normalizeStyle(_unref(printTableWidth)),
                          stationIds: _unref(sequencialStationIds)
                        }, null, 8, ["rows", "resolution", "date", "headerUnits", "style", "stationIds"]),
                        (_unref(isWeather) && _unref(stationId))
                          ? (_openBlock(), _createElementBlock("table", {
                              key: 2,
                              style: _normalizeStyle(_unref(printTableWidth)),
                              class: "table-summary"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaryStore).getWeatherRows(_unref(stationId), _unref(resolution)), (row) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: row.title
                                }, [
                                  _createElementVNode("td", _hoisted_24, _toDisplayString(row.title), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.values
                      .slice(_unref(printColSize) * index2, _unref(printColSize) * (index2 + 1))
                      .concat(
                        Array(
                          _unref(printColSize) - row.values.slice(_unref(printColSize) * index2, _unref(printColSize) * (index2 + 1)).length
                        )
                      ), (value, index4) => {
                                    return (_openBlock(), _createElementBlock("td", { key: index4 }, _toDisplayString(value), 1))
                                  }), 128))
                                ]))
                              }), 128))
                            ], 4))
                          : (_openBlock(), _createElementBlock("table", {
                              key: 3,
                              style: _normalizeStyle(_unref(printTableWidth)),
                              class: "table-summary"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(definitionInfo)?.definitionSummary, (info, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                  _createElementVNode("td", _hoisted_25, _toDisplayString(info.title), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaryStore).getRows(
                      _unref(definitionInfo),
                      info,
                      (_unref(chunkedSequencialStationIds)[index2] || []).concat(
                        Array.from(
                          Array(_unref(printColSize) - (_unref(chunkedSequencialStationIds)[index2] || []).length * _unref(headerUnits).length)
                        )
                      )
                    ), (row, index) => {
                                    return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(row?.value?.toFixed ? row?.value?.toFixed(_unref(initDataStore).decimal(row.key)) : row?.value), 1))
                                  }), 128))
                                ]))
                              }), 128))
                            ], 4))
                      ], 2))
                    }), 128))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_unref(isRui))
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                (_unref(isRui))
                  ? (_openBlock(), _createBlock(DataRuiTable, {
                      key: 0,
                      data: _unref(reportData).dataRui
                    }, null, 8, ["data"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(showSummary))
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                style: _normalizeStyle(_unref(summaryWrapperStyle)),
                class: "table-summary-wrapper hide-print"
              }, [
                _createElementVNode("table", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(definitionInfo)?.definitionSummary, (info, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_28, _toDisplayString(info.title), 1)
                    ]))
                  }), 128))
                ]),
                (!_unref(isWeather))
                  ? (_openBlock(), _createElementBlock("table", {
                      key: 0,
                      style: _normalizeStyle(_unref(tableWidth)),
                      class: "table-summary"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(definitionInfo)?.definitionSummary, (info, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_29, _toDisplayString(info.title), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaryStore).getRows(_unref(definitionInfo), info, _unref(sequencialStationIds)), (row, index) => {
                            return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(row?.value?.toFixed ? row?.value?.toFixed(_unref(initDataStore).decimal(row.key)) : row?.value), 1))
                          }), 128))
                        ]))
                      }), 128))
                    ], 4))
                  : _createCommentVNode("", true),
                (_unref(isWeather) && _unref(stationId))
                  ? (_openBlock(), _createElementBlock("table", {
                      key: 1,
                      style: _normalizeStyle(_unref(tableWidth)),
                      class: "table-summary table-summary-weather"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaryStore).getWeatherRows(_unref(stationId), _unref(resolution)), (row, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_30, _toDisplayString(row.title), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.values, (value, index2) => {
                            return (_openBlock(), _createElementBlock("td", { key: index2 }, _toDisplayString(value), 1))
                          }), 128))
                        ]))
                      }), 128))
                    ], 4))
                  : _createCommentVNode("", true),
                (_unref(isWeather) && _unref(stationId))
                  ? (_openBlock(), _createBlock(WdCountRateTable, {
                      key: 2,
                      directions: _unref(summaryStore).getWdCountRate(_unref(stationId), _unref(resolution))
                    }, null, 8, ["directions"]))
                  : _createCommentVNode("", true)
              ], 4))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !loading.value]
    ])
  ], 64))
}
}

})